
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/flipper",
      function () {
        return require("private-next-pages/flipper/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/flipper"])
      });
    }
  